type ProcessHeaderProps = {   
  title: string;
  pronoun?: string;
}

export function ProcessHeader({ title, pronoun = "os" }: ProcessHeaderProps) {
  return (
    <div className="py-3">
      <h4 className="pt-0 header-title fs-4 text-dark fw-bold">
        Lista de {title}
      </h4>
      <p className="fs-6 text-dark text-opacity-75 mb-0">
        {pronoun === "a"
          ? "Aqui são listadas todas as suas "
          : "Aqui são listados todos os seus "}
        {title.toLowerCase()}
      </p>
    </div>
  );
}
